import { render, staticRenderFns } from "./BoxFilter.vue?vue&type=template&id=a80c1540&scoped=true&"
import script from "./BoxFilter.vue?vue&type=script&lang=js&"
export * from "./BoxFilter.vue?vue&type=script&lang=js&"
import style0 from "./BoxFilter.vue?vue&type=style&index=0&id=a80c1540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c1540",
  null
  
)

export default component.exports